import axiosService from "@command-center-app/services/axios.service";

type MethodType = "get" | "post" | "put" | "patch" | "delete";

export const apiMiddleware =
  ({ dispatch }: any) =>
  (next: any) =>
  async (action: any) => {
    if (action.type !== "API_CALL") return next(action);

    const {
      method = "GET",
      url,
      data,
      onSuccess,
      onError,
      onStart,
      headers,
    } = action.payload;

    if (onStart) dispatch({ type: onStart });

    try {
      const methodType = method.toLowerCase() as MethodType;
      const response = await axiosService[methodType](url, data, { headers });
      console.log("url to send api: ", url);
      dispatch({
        type: onSuccess,
        payload: response?.data,
      });
    } catch (error: any) {
      dispatch({
        type: onError,
        payload:
          error?.response?.data?.error ||
          error?.message ||
          "something went wrong",
      });
    }
  };
